<template>
    <div>
        <!-- Modal para historial de operaciones -->
        <b-modal ref="historialOperaciones" size="xl" hide-footer no-close-on-backdrop title="Historial de operaciones">
            <div class="mb-3">
                <!-- Primera fila de filtros -->
                <div class="row mb-2">
                    <!-- Filtro por rango de fechas -->
                    <div class="col-md-3 col-sm-6 mb-2">
                        <label for="fecha-desde" class="form-label">Fecha desde:</label>
                        <b-form-input
                            id="fecha-desde"
                            type="date"
                            v-model="fechaDesde"
                        ></b-form-input>
                    </div>
                    
                    <div class="col-md-3 col-sm-6 mb-2">
                        <label for="fecha-hasta" class="form-label">Fecha hasta:</label>
                        <b-form-input
                            id="fecha-hasta"
                            type="date"
                            v-model="fechaHasta"
                        ></b-form-input>
                    </div>
                    
                    <!-- Filtro por código de alerta -->
                    <div class="col-md-3 col-sm-6 mb-2">
                        <label for="codigo-alerta" class="form-label">Código de alerta:</label>
                        <b-form-select
                            id="codigo-alerta"
                            v-model="codigoAlertaFiltro"
                            :options="codigosAlertaDisponibles"
                        ></b-form-select>
                    </div>
                    
                    <div class="col-md-3 col-sm-6 mb-2">
                        <label for="estado-alerta" class="form-label">Estado de alerta:</label>
                        <b-form-select
                            id="estado-alerta"
                            v-model="estadoAlertaFiltro"
                            :options="estadosAlertaDisponibles"
                        ></b-form-select>
                    </div>
                </div>
                
                <!-- Segunda fila con botones de acción -->
                <div class="row">
                    <div class="col-12">
                        <b-button variant="primary" @click="filtrarPorFechaCodigo" :disabled="loaderTabla" class="mr-2 mb-2">
                            <i class="fas fa-filter mr-1"></i>
                            Filtrar
                        </b-button>
                        <b-button variant="secondary" @click="limpiarFiltro" :disabled="loaderTabla" class="mr-2 mb-2">
                            <i class="fas fa-times-circle mr-1"></i>
                            Limpiar
                        </b-button>
                    </div>
                </div>
            </div>
            <b-alert
                v-if="mensajeAlerta"
                variant="warning"
                show
                class="mb-3"
            >
                {{ mensajeAlerta }}
            </b-alert>
            <div class="table-responsive">
                <div v-if="loaderTabla" class="d-flex justify-content-center align-items-center" style="height: 200px;">
                    <b-spinner label="Cargando..." type="grow" variant="primary"></b-spinner>
                </div>
                <b-table
                    v-else
                    :items="registrosFiltrados.length > 0 ? registrosFiltrados : historialOperaciones"
                    :fields="fieldsOperaciones"
                    :per-page="opcionesPaginate.perPage"
                    :current-page="opcionesPaginate.currentPage"
                    striped hover small responsive
                    id="table-operaciones"
                >
                    <template #cell(id)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(timestamp)="data">
                        {{ formatFechaColombia(data.item.timestamp) }} {{ formatHoraColombia(data.item.timestamp) }}
                    </template>
                    <template #empty>
                        <div class="text-center text-warning py-4">
                            <b-icon icon="exclamation-triangle-fill" variant="warning" font-scale="2"></b-icon>
                            <div>No se encontraron resultados para los filtros seleccionados.</div>
                        </div>
                    </template>
                </b-table>
                <b-pagination
                    v-model="paginaActual"
                    :total-rows="opcionesPaginate.total"
                    :per-page="opcionesPaginate.perPage"
                    aria-controls="table-operaciones"
                    @change="cambiarPagina"
                >
                </b-pagination>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            historialOperaciones: [],
            fieldsOperaciones: [
                { key: 'id', label: 'Item' },
                { key: 'detalle_alerta', label: 'Detalle de alerta' },
                { key: 'estado', label: 'Estado de alerta' },
                { key: 'tipo_unidad', label: 'Tipo de unidad' },
                { key: 'cod_alerta', label: 'Código de alerta' },
                { key: 'timestamp', label: 'Fecha y hora' }
            ],
            fechaDesde: '',
            fechaHasta: '',
            fechaFiltro: '', // Mantener para compatibilidad
            codigoAlertaFiltro: '',
            codigosAlertaDisponibles: [],
            estadosAlertaDisponibles: [
                { value: '', text: 'Todos los estados' },
                { value: 1, text: 'Activo' },
                { value: 3, text: 'Inactivo' }
            ],
            estadoAlertaFiltro: '',
            loaderTabla: false,
            opcionesPaginate: {},
            registrosFiltrados: [],
            paginaActual: 1,
            totalRegistros: 0,
            itemUnidad: null,
            mensajeAlerta: ''
        }
    },
    methods: {
        mostrarHistorialOperaciones(item) {
            this.itemUnidad = item;
            this.paginaActual = 1;
            this.cargarPagina();
            this.$refs['historialOperaciones'].show();
        },
        async cargarPagina() {
            this.loaderTabla = true;
            try {
                const response = await axios.get(`api/historialoperaciones-all/${this.itemUnidad.cbi}?page=${this.paginaActual}`, {
                    headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
                });
                // console.log('Historial de operaciones response:', response.data);
                this.historialOperaciones = response.data.data;
                this.opcionesPaginate = response.data;
                this.totalRegistros = response.data.total;
                this.registrosFiltrados = [];
                this.fechaFiltro = '';
                this.codigoAlertaFiltro = '';
                this.mensajeAlerta = '';
                this.mostrarCodigosAlertaDisponibles();
            } catch (error) {
                console.error('Error fetching historial de operaciones:', error);
            }
            this.loaderTabla = false;
        },
        filtrarPorFechaCodigo(page = 1) {
            // Validar rango de fechas
            if (this.fechaDesde && this.fechaHasta && this.fechaDesde > this.fechaHasta) {
                this.mensajeAlerta = 'La fecha desde no puede ser mayor a la fecha hasta.';
                return;
            }
            
            if (!this.fechaDesde && !this.fechaHasta && !this.codigoAlertaFiltro && !this.estadoAlertaFiltro) {
                this.mensajeAlerta = 'Debes seleccionar al menos un filtro: rango de fechas, código de alerta o estado de alerta.';
                this.registrosFiltrados = [];
                return;
            }
            
            this.loaderTabla = true;
            this.mensajeAlerta = '';
            
            const params = {
                cbi: this.itemUnidad.cbi,
                fecha_desde: this.fechaDesde || null,
                fecha_hasta: this.fechaHasta || null,
                codigo_alerta: this.codigoAlertaFiltro || null,
                estado_alerta: this.estadoAlertaFiltro || null,
                page: page
            };
            
            axios.post(`api/get-historial-operaciones-filtradas`, params, {
                headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
            })
            .then(response => {
                console.log('Filtrado response:', response.data);
                this.registrosFiltrados = response.data.data;
                this.opcionesPaginate = response.data;
                this.totalRegistros = response.data.total;
                this.paginaActual = response.data.current_page;
                if (this.registrosFiltrados.length === 0) {
                    this.historialOperaciones = [];
                    this.mensajeAlerta = 'No se encontraron registros con los filtros aplicados.';
                }
            })
            .catch(error => {
                console.error('Error filtrando historial de operaciones:', error);
                this.registrosFiltrados = [];
                this.historialOperaciones = [];
                this.mensajeAlerta = 'Error al filtrar los datos. Intenta nuevamente.';
            })
            .finally(() => {
                this.loaderTabla = false;
            });
        },
        cambiarPagina(page) {
            if (this.registrosFiltrados.length > 0 || this.fechaFiltro || this.codigoAlertaFiltro) {
                this.filtrarPorFechaCodigo(page);
            } else {
                this.paginaActual = page;
                this.cargarPagina();
            }
        },
        limpiarFiltro() {
            this.paginaActual = 1;
            this.fechaDesde = '';
            this.fechaHasta = '';
            this.fechaFiltro = '';
            this.codigoAlertaFiltro = '';
            this.estadoAlertaFiltro = '';
            this.registrosFiltrados = [];
            this.mensajeAlerta = '';
            this.cargarPagina();
        },
        mostrarCodigosAlertaDisponibles() {
            axios.get(`api/detalle-alertas`, {
                headers: { Authorization: `Bearer ${this.$store.state.user.token}` }
            })
            .then(response => {
                // Espera que la API devuelva un array de objetos con cod_alerta y detalle_alerta
                this.codigosAlertaDisponibles = response.data.map(item => ({
                    value: item.cod_alerta,
                    text: `${item.cod_alerta} - ${item.detalle_alerta}`
                }));
            })
            .catch(error => {
                console.error('Error obteniendo códigos de alerta:', error);
                this.codigosAlertaDisponibles = [];
            });
        },
        formatFechaColombia(ts) {
            if (!ts) return '';
            const fecha = new Date(ts);
            return fecha.toLocaleDateString('es-CO', { timeZone: 'America/Bogota' });
        },
        formatHoraColombia(ts) {
            if (!ts) return '';
            const fecha = new Date(ts);
            return fecha.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'America/Bogota' });
        }
    }
}
</script>